(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const coarse = window.matchMedia("(pointer: coarse)").matches;

  const reveal = () => {
    const nodes = document.querySelectorAll(".je-reveal");
    if (!nodes.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach((el) => el.classList.add("is-in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -6% 0px" }
    );

    nodes.forEach((el) => io.observe(el));
  };

  const loadHeroVideo = () => {
    const media = document.querySelector(".je-hero__media");
    if (!media) return;
    const video = media.querySelector("video");
    const poster = media.querySelector(".je-hero__poster");
    if (!video) return;

    const src = video.getAttribute("data-src");
    if (!src) {
      video.classList.add("is-ready");
      if (poster) poster.classList.add("is-hidden");
      video.play().catch(function () {});
      return;
    }

    const start = () => {
      if (video.getAttribute("data-loaded") === "true") return;
      video.setAttribute("data-loaded", "true");
      const source = document.createElement("source");
      source.src = src;
      source.type = "video/mp4";
      video.appendChild(source);
      video.preload = "auto";
      video.load();
      const show = () => {
        video.classList.add("is-ready");
        video.play().catch(function () {});
        if (poster) poster.classList.add("is-hidden");
      };
      video.addEventListener("canplay", show, { once: true });
      video.addEventListener("playing", show, { once: true });
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(start, { timeout: 1200 });
    } else {
      window.setTimeout(start, 400);
    }

    const ctaVideo = document.querySelector(".je-cta__media video");
    if (ctaVideo && ctaVideo.getAttribute("data-src")) {
      const loadCta = () => {
        if (ctaVideo.getAttribute("data-loaded") === "true") return;
        ctaVideo.setAttribute("data-loaded", "true");
        const source = document.createElement("source");
        source.src = ctaVideo.getAttribute("data-src");
        source.type = "video/mp4";
        ctaVideo.appendChild(source);
        ctaVideo.load();
        ctaVideo.play().catch(function () {});
      };
      window.addEventListener("load", function () {
        window.setTimeout(loadCta, 1600);
      });
    }
  };

  /* Native-scroll lerp: keeps position:sticky working */
  const smoothScroll = () => {
    if (reduce || coarse) return;

    document.documentElement.classList.add("je-smooth");

    let current = window.scrollY || 0;
    let target = current;
    let running = false;
    const ease = 0.072;

    const maxScroll = () =>
      Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

    const clamp = (n) => Math.max(0, Math.min(n, maxScroll()));

    const tick = () => {
      current += (target - current) * ease;
      if (Math.abs(target - current) < 0.2) {
        current = target;
        window.scrollTo(0, current);
        running = false;
        return;
      }
      window.scrollTo(0, current);
      requestAnimationFrame(tick);
    };

    const start = () => {
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    };

    window.addEventListener(
      "wheel",
      (e) => {
        if (e.ctrlKey) return;
        e.preventDefault();
        target = clamp(target + e.deltaY);
        start();
      },
      { passive: false }
    );

    window.addEventListener("keydown", (e) => {
      const tag = (e.target && e.target.tagName) || "";
      if (/INPUT|TEXTAREA|SELECT/.test(tag) || e.target.isContentEditable) return;

      let delta = 0;
      if (e.key === "ArrowDown") delta = 90;
      else if (e.key === "ArrowUp") delta = -90;
      else if (e.key === "PageDown") delta = window.innerHeight * 0.86;
      else if (e.key === "PageUp") delta = -window.innerHeight * 0.86;
      else if (e.key === " " && !e.shiftKey) delta = window.innerHeight * 0.86;
      else if (e.key === " " && e.shiftKey) delta = -window.innerHeight * 0.86;
      else if (e.key === "Home") {
        e.preventDefault();
        target = 0;
        start();
        return;
      } else if (e.key === "End") {
        e.preventDefault();
        target = maxScroll();
        start();
        return;
      } else return;

      e.preventDefault();
      target = clamp(target + delta);
      start();
    });

    document.addEventListener("click", (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href");
      if (!id || id === "#") return;
      const el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      target = clamp(el.getBoundingClientRect().top + window.scrollY - 8);
      start();
    });

    window.addEventListener(
      "scroll",
      () => {
        if (running) return;
        current = window.scrollY;
        target = current;
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      target = clamp(target);
      current = clamp(window.scrollY);
    });
  };

  const pinCraft = () => {
    const intro = document.querySelector(".je-craft__sticky");
    const section = document.querySelector(".je-craft");
    if (!intro || !section) return;

    const desktop = window.matchMedia("(min-width: 990px)");

    const update = () => {
      if (!desktop.matches) {
        intro.classList.remove("is-fixed", "is-bottom");
        intro.style.width = "";
        intro.style.left = "";
        intro.style.top = "";
        return;
      }

      const gap = 88;
      const introH = intro.offsetHeight;
      const rect = section.getBoundingClientRect();
      const parent = intro.parentElement;
      if (parent && !parent.dataset.jeMin) {
        parent.style.minHeight = intro.offsetHeight + "px";
        parent.dataset.jeMin = "true";
      }

      if (rect.top > gap) {
        intro.classList.remove("is-fixed", "is-bottom");
        intro.style.top = "";
        intro.style.left = "";
        intro.style.width = "";
        return;
      }

      const stop = rect.bottom - introH - gap;
      if (stop <= 0) {
        intro.classList.add("is-bottom");
        intro.classList.remove("is-fixed");
        intro.style.top = "";
        intro.style.left = "";
        intro.style.width = "";
        return;
      }

      const parentRect = parent.getBoundingClientRect();
      intro.classList.add("is-fixed");
      intro.classList.remove("is-bottom");
      intro.style.top = gap + "px";
      intro.style.width = parentRect.width + "px";
      intro.style.left = parentRect.left + "px";
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  };

  const boot = () => {
    reveal();
    loadHeroVideo();
    smoothScroll();
    pinCraft();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
